/*
 * Copyright 2016 Lutrons Ltd. All Rights Reserved.
 *
 */
import React from 'react';
import {withRouter} from "react-router";
import queryString from 'query-string';

import {Grid, Row, Well, Button, Col, Glyphicon} from 'react-bootstrap';
import ProductStore from '../../stores/ProductStore';
import ProductEditView from './ProductEditView.react';

class ProductEditor extends React.Component {
    constructor(props) {
        console.log("[JobsView] - initialisation");

        var jid = queryString.parse(props.location.search).id;

        super(props);
        this.state = {
            productId : jid
        };

        this._onProductChange = this._onProductChange.bind(this);
    }

    componentDidMount() {
        console.log("[JobOverviewView] - componentDidMount");
        ProductStore.addChangeListener(this._onProductChange) ;
    }

    componentWillUnmount() {
        console.log("[JobOverviewView] - componentWillUnmount");
        ProductStore.removeChangeListener(this._onProductChange);
    }

   
    _onProductChange() {
        var products = ProductStore.products() ;
        console.log("_onProductChange : LOADED PRODUCTS-", products);
    }
     
    productEditFinished(changesSaved) {
        console.log("Product Edit Finished: ", changesSaved);
    }

  
    render() {              
        return (
            <Grid>
               <Row>
                   <Well className="jobHeader">
                       <h1>Product Edit</h1>    
                   </Well>
               </Row>
               <Row>
                   <Col>
                        <ProductEditView productUuid={this.state.productId} onFinished={this.productEditFinished.bind(this)} />
                   </Col>
               </Row>
           </Grid>
        );
    }
}

export default withRouter(ProductEditor);



// WEBPACK FOOTER //
// ./src/app/components/products/productEditor.js